module.exports = __webpack_public_path__ + "static/media/Energy-Competition.54340847.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Energy-Competition.png
// module id = 1745
// module chunks = 1